import { createElement } from 'react';
import styles from './VisuallyHidden.module.css';
/**
 * Renders content that is visually hidden but exposed to assistive
 * technology. Use sparingly — visible labels are almost always better.
 */
export const VisuallyHidden = ({ as = 'span', children, className, id }) => createElement(as, {
    className: [styles.root, className].filter(Boolean).join(' '),
    ...(id !== undefined ? { id } : {}),
}, children);
//# sourceMappingURL=VisuallyHidden.js.map